{ "cosmos:cosmoshub-4/slip44:118": "cosmos" }
